import { isBoolean, isString, isNumber, map, isArray, find, get } from 'lodash';
import { CLIENT_LOG_TYPES } from '../../consts/logs';

import { serializeManagerName } from './general';
import { getCallURLById } from '../../utils/parsers';
import { serializeFinalCallSummary, serializeLogAttachments } from './log';

// Парсинг данных о звонке, которые приходят при обновлении по WS.
export function parseCallForLog(unparsedData) {
  if (!unparsedData || !unparsedData.call) {
    return null;
  }

  const unparsedCall = unparsedData.call;
  const {
    answered_at: answeredAt,
    call_reason_ids: selectedReasonIds,
    communication_log_id: communicationId,
    final_call_summary: finalCallSummary,
    finished_at: finishedAt,
    id,
    is_answered: isAnswered,
    is_callback: isCallback,
    is_incoming: unparsedIsIncoming,
    manager_id: unparsedManagerId,
    person_id: unparsedPersonId,
    person_type: personType,
    record_url: recordUrl,
    started_at: startedAt,
    updated_at: updatedAt,
  } = unparsedCall;
  const isIncoming = isBoolean(unparsedIsIncoming) ? unparsedIsIncoming : null;
  const managerId = unparsedManagerId ? String(unparsedManagerId) : null;
  const personId = unparsedPersonId ? String(unparsedPersonId) : null;
  const communication = {
    active: false,
    id: communicationId ? String(communicationId) : null,
    managerId,
    personId,
    personType: isString(personType) ? personType.toLowerCase() : null,
    time: isNumber(startedAt) ? startedAt : null,
    type: CLIENT_LOG_TYPES.CALL,
    updatedAt: isNumber(updatedAt) ? updatedAt : null,
    call: {
      answeredAt: isNumber(answeredAt) ? answeredAt : null,
      callUrl: getCallURLById(id),
      editable: false, // Этот флаг зависит от хранилища и установится позже в саге.
      editableExpiresAt: null, // Этот флаг зависит от хранилища и установится позже в саге.
      finalCallSummary: serializeFinalCallSummary(finalCallSummary),
      finishedAt: isNumber(finishedAt) ? finishedAt : null,
      id: id ? String(id) : null,
      isAnswered: isBoolean(isAnswered) ? isAnswered : null,
      isCallback: isBoolean(isCallback) ? isCallback : false,
      isIncoming: isBoolean(isIncoming) ? isIncoming : null,
      reasonDescription: null, // Это поле зависит от хранилища и установится позже в саге.
      reasonGroups: null, // Это поле зависит от хранилища и установится позже в саге.
      reasons: null, // Это поле зависит от хранилища и установится позже в саге.
      recordUrl: null, // Это поле зависит от хранилища и установится позже в саге.
      requireNoteIds: null, // Это поле зависит от хранилища и установится позже в саге.
      segments: null, // Это поле зависит от хранилища и установится позже в саге.
      selectedReasonIds: map(selectedReasonIds, String), // Это поле может измениться в саге.
      selectedSegmentId: null, // Это поле зависит от хранилища и установится позже в саге.
    },
  };

  const unparsedPersons = unparsedData.persons;

  if (managerId && isArray(unparsedPersons)) {
    const unparsedManager = find(unparsedPersons, {
      person_id: +managerId,
      person_type: 'manager',
    });
    communication.name = serializeManagerName(
      'call',
      managerId,
      get(unparsedManager, 'full_name'),
      isIncoming
    );

    if (personId) {
      const unparsedContact = find(unparsedPersons, {
        person_id: +personId,
      });

      const isSupervisorInCall =
        get(unparsedManager, 'sip_supervisor') ||
        get(unparsedContact, 'sip_supervisor');
      communication.recordUrl =
        !isSupervisorInCall && isString(recordUrl) ? recordUrl : null;
    }
  }

  return communication;
}

// Парсинг данных о заметке, которые приходят при обновлении по WS.
export function parseNoteForLog(unparsedData) {
  if (!unparsedData || !unparsedData.note) {
    return null;
  }

  const unparsedNote = unparsedData.note;
  const {
    body: text,
    communication_log_id: communicationId,
    created_at: createdAt,
    id,
    manager_id: unparsedManagerId,
    notable_id: personId,
    notable_type: personType,
    updated_at: updatedAt,
    attachments,
  } = unparsedNote;
  const managerId = unparsedManagerId ? String(unparsedManagerId) : null;
  const communication = {
    active: false,
    id: communicationId ? String(communicationId) : null,
    managerId,
    personId: personId ? String(personId) : null,
    personType: isString(personType) ? personType.toLowerCase() : null,
    time: isNumber(createdAt) ? createdAt : null,
    type: CLIENT_LOG_TYPES.NOTE,
    updatedAt: isNumber(updatedAt) ? updatedAt : null,
    note: {
      id: id || null,
      isPinned: !!unparsedNote.is_pinned,
      text: isString(text) ? text : null,
      editable: false, // Этот флаг зависит от хранилища и установится позже в саге.
      editableExpiresAt: null, // Этот флаг зависит от хранилища и установится позже в саге.
      attachments: serializeLogAttachments(attachments),
    },
  };

  const unparsedPersons = unparsedData.persons;

  if (managerId && isArray(unparsedPersons)) {
    const unparsedManager = find(unparsedPersons, {
      person_id: +managerId,
      person_type: 'manager',
    });
    const name = get(unparsedManager, 'full_name');
    communication.name = serializeManagerName('note', managerId, name);
  }

  return communication;
}
